import React from "react";

class MightyBenefits extends React.Component {
  render() {
    return (
        <section className="section bg-gradient-benefit">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center section_title">
                  <h1
                      className="font-weight-bold wherehome-white"
                      style={{ color: "#fff" }}
                  >
                    MIGHTY BENEFITS
                  </h1>
                </div>
              </div>
            </div>
            <div className="row" id="counter">
              <div className="col-lg-6">
                <div className="text-white lan_funfact p-4 mt-3 rounded text-white">
                  <div className="benefittitle">Global Coverage</div>
                  <p className="lan_fun_name mb-0">
                    Supports 16 Bands 4G network frequencies worldwide
                  </p>
                  <div style={{ clear: "both", height: "20px" }} />

                  <div className="benefittitle">Smart & Simple</div>
                  <p className="lan_fun_name mb-0">
                    One-touch access to WiFi in over 100+ countries - no
                    SIMs needed
                  </p>
                  <div style={{ clear: "both", height: "20px" }} />

                  <div className="benefittitle">Shareable</div>
                  <p className="lan_fun_name mb-0">
                    Connect up to 10 devices at once. Keep your travel buddies
                    online too!
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="text-white lan_funfact p-4 mt-3 rounded text-white">
                  <div className="benefittitle">Blazing Fast Speeds</div>
                  <p className="lan_fun_name mb-0">
                    Get the fastest 4G LTE mobile WiFi speeds worldwide
                  </p>
                  <div style={{ clear: "both", height: "20px" }} />

                  <div className="benefittitle">Portable Global Smart Hub</div>
                  <p className="lan_fun_name mb-0">
                    Keep your phone, laptop, and IOT devices online everywhere at
                    one low rate. Programmable features coming soon.
                  </p>
                  <div style={{ clear: "both", height: "20px" }} />

                  <div className="benefittitle">Long Lasting</div>
                  <p className="lan_fun_name mb-0">
                    Stay powered-on all day long with 12 hours of WiFi battery
                    life
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }
}

export default MightyBenefits;



// WEBPACK FOOTER //
// ./src/pages/about/MightyBenefits.js